export const handleWheel = (e: any): void => {
  e.target.blur();
};
